export default "__VITE_ASSET__C1Swt9VX__"